export const FeedbacksCollection = "Feedbacks";
